// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "SubFooter-module--wrapper--8Yiza";
export var text = "SubFooter-module--text--GFsVq";
export var link = "SubFooter-module--link--rPATs";